export const DOMAIN_KEY = 'aerial_domain';

export const DOMAINS = {
  executive: {
    key: 'executive',
    label: 'Executive',
    tabs: ['OVERVIEW'],
    summaryTitle: 'Jio Ops Performance Summary for',
    summaryHighlight: 'Aerial Telecom',
    summarySubtitle:
      'Cross-module view of North zone for {period}, covering the executive overview of all the modules.',
    pills: [
      { label: 'Coverage', value: '4 Circles · 14 MPs' },
      { label: 'Circles', value: 'HP · JA · KS · UW' },
    ],
  },
  fibre: {
    key: 'fibre',
    label: 'Fibre',
    tabs: ['EXECUTIVE OVERVIEW', 'MANPOWER GAP', 'PM PENALTY', 'CM PENALTY'],
    summaryTitle: 'Jio Ops Performance Summary for',
    summaryHighlight: 'Aerial Telecom',
    summarySubtitle:
      'North zone Fibre audit for {period} covering PM and CM penalty exposure.',
    pills: [
      { label: 'Scope', value: '40,903 KM' },
      { label: 'CMPs', value: '14' },
      { label: 'Circles', value: '4' },
      { label: 'Net Payable', value: '₹337.0L' },
    ],
  },
  tower: {
    key: 'tower',
    label: 'Tower',
    tabs: ['EXECUTIVE OVERVIEW', 'PM PENALTY', 'CM PENALTY'],
    summaryTitle: 'Jio Ops Performance Summary for',
    summaryHighlight: 'Aerial Telecom',
    summarySubtitle:
      'North zone Tower audit for {period} covering PM and CM penalty exposure.',
    pills: [
      { label: 'Sites', value: '21,129' },
      { label: 'CMPs', value: '14' },
      { label: 'Circles', value: '4' },
      { label: 'Net Payable', value: 'NA' },
    ],
  },
  misc: {
    key: 'misc',
    label: 'Miscellaneous',
    tabs: ['EXECUTIVE OVERVIEW', 'PM PENALTY', 'CM PENALTY'],
    summaryTitle: 'Jio Ops Performance Summary for',
    summaryHighlight: 'Aerial Telecom',
    summarySubtitle:
      'North zone OSC, AG1 & MFL audit for {period} covering PM and CM penalty exposure.',
    pills: [
      { label: 'OSC Sites', value: '7,214' },
      { label: 'AG1 Sites', value: '62' },
      { label: 'MFL Sites', value: '308' },
      { label: 'Circles', value: '4' },
      { label: 'Net Payable', value: 'NA' },
    ],
  },
};

export const DOMAIN_LIST = [DOMAINS.executive, DOMAINS.fibre, DOMAINS.tower, DOMAINS.misc];

export const DEFAULT_DOMAIN = 'executive';

export function getSummaryPills(domain, month) {
  const config = DOMAINS[domain];
  if (!config) return [];
  return config.pills.map((pill) => {
    if (domain === 'fibre' && pill.label === 'Net Payable' && month === "Feb'26") {
      return { ...pill, value: 'NA' };
    }
    return pill;
  });
}

export function resolveDomain(stored) {
  return DOMAINS[stored] ? stored : DEFAULT_DOMAIN;
}
